// extracted by mini-css-extract-plugin
export var contentWrapper = "Podcast-module--content-wrapper--3jVlZ";
export var light = "Podcast-module--light--2r1y1";
export var mainContent = "Podcast-module--main-content--1DMX1";
export var mediaBtns = "Podcast-module--mediaBtns--3CHAC";